const services = [
  {
    icon: 'ri-pencil-ruler-2-line',
    title: 'Landscape Design',
    description: 'Custom landscape designs tailored to your vision, property, and lifestyle needs',
  },
  {
    icon: 'ri-drop-line',
    title: 'Irrigation Systems',
    description: 'Professional irrigation installation and maintenance for efficient water management',
  },
  {
    icon: 'ri-plant-line',
    title: 'Maintenance',
    description: 'Regular lawn care and landscape maintenance to keep your property looking its best',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Hardscaping',
    description: 'Patios, walkways, retaining walls, and outdoor living spaces built to last',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Sod Installation',
    description: 'Premium sod installation for instant, lush green lawns that transform your yard',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Seasonal Cleanup',
    description: 'Spring and fall cleanup services to prepare your landscape for every season',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-2 h-2 bg-emerald-600 rounded-full"></div>
            <span className="text-emerald-600 font-semibold tracking-wider text-sm uppercase">
              Our Services
            </span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Complete Landscaping &<br />Irrigation Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            From design to installation and ongoing maintenance, we provide comprehensive services to create and maintain beautiful outdoor spaces
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-emerald-100 rounded-full mb-6 group-hover:bg-emerald-600 transition-colors">
                <i className={`${service.icon} text-3xl text-emerald-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
